import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-calendarnotrequired',
  templateUrl: './calendarnotrequired.component.html'
})
export class CalendarnotrequiredComponent implements OnInit {
  @Input() formName: string;
  @Input() form: FormGroup;
  @Output() selecteddate = new EventEmitter();

  dateMask = '____-__-__';
  se;
  constructor() { }

  ngOnInit() {
    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
  }

  changedDate(evt) {
    this.form.patchValue({
      [this.formName]: moment(evt).add(3, 'h').format('YYYY-MM-DD')
    });
  }

  onInputDate(event): void {
    let cursorPosition = event.path[0].selectionEnd;
    if (event.inputType === 'deleteContentBackward' && (cursorPosition === 4 || cursorPosition === 7)) {
      event.path[0].value = event.path[0].value.substring(0, cursorPosition - 1) + event.path[0].value.substring(cursorPosition);
      cursorPosition--;
    }
    if (event.inputType === 'insertText' && (event.path[0].value.length > 10)) {
      event.path[0].value = event.path[0].value.substring(0, event.path[0].value.length - 1);
    }
    this.dateMask = event.path[0].value.toString();
    this.dateMask = this.dateMask.replace(/\D/g, '');
    let mask = '';
    for (let i = 0; i < this.dateMask.length; i++) {
      mask += this.dateMask[i];
      if (i === 3 || i === 5) {
        mask += '-';
        if (cursorPosition === 4 || cursorPosition === 7) { cursorPosition++; }
      }
    }
    event.path[0].value = mask.toString();
    event.path[0].selectionStart = cursorPosition;
    event.path[0].selectionEnd = cursorPosition;
    if (event.path[0].value.length === 10) {
      this.changedDate(event);
    }
  }

}
